const DEFAULT_AD_PAGE_SIZE = 12;
const ICON_FILL_COLOR = 'rgba(40, 134, 222, 1)';

export {
  DEFAULT_AD_PAGE_SIZE,
  ICON_FILL_COLOR,
};
